import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Grid,
} from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { getPlanInfo } from "./utils/plan-utils";

const PLAN_NAMES = {
  freemium: "Freemium",
  standard: "Standard",
  franquicia: "Franquicia",
  enterprise: "Enterprise",
};

const getNuevosModulos = (actualModules, destinoModules) => {
  return destinoModules.filter((mod) => !actualModules.includes(mod));
};

const UpgradePlanModal = ({ open, onClose, planActual, planDestino }) => {
  const actualInfo = getPlanInfo(planActual);
  const destinoInfo = getPlanInfo(planDestino);

  if (!destinoInfo) return null;

  const nuevosModulos = getNuevosModulos(actualInfo.modules, destinoInfo.modules);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#fff7ed", borderBottom: "1px solid #ffe0c1" }}>
        <Box display="flex" alignItems="center" gap={1}>
          <RocketLaunchIcon sx={{ color: "#ff770d" }} />
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Mejora tu plan a {PLAN_NAMES[planDestino]}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          backgroundColor: "#fffdfa",
          "& .MuiTypography-body2": {
            color: "#4a4a4a",
          },
        }}
      >
        <Typography variant="body1" mb={2}>
          Para poder acceder a este modulo debes adquirir el plan {PLAN_NAMES[planDestino]}. Actualmente tienes el plan{" "}
          <b>{PLAN_NAMES[planActual]}</b> con acceso a:
        </Typography>

        <Box p={2} mb={2} borderRadius={2} border="1px solid #ffd8b2">
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Módulos actuales:
          </Typography>
          <Grid container spacing={1}>
            {actualInfo.modules.map((mod) => (
              <Grid item xs={12} sm={6} key={mod}>
                <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      backgroundColor: "#ff770d",
                      display: "inline-block",
                      mr: 1,
                    }}
                  />
                  {mod}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box p={2} mb={2} borderRadius={2} border="1px solid #ffd8b2">
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Nuevos módulos al actualizar:
          </Typography>
          {nuevosModulos.length > 0 ? (
            <Grid container spacing={1}>
              {nuevosModulos.map((mod) => (
                <Grid item xs={12} sm={6} key={mod}>
                  <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      component="span"
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "#ff770d",
                        display: "inline-block",
                        mr: 1,
                      }}
                    />
                    {mod}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body2" sx={{ pl: 2 }}>
              Ya tienes todos los módulos de este plan
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button sx={{ color: "#ff770d" }} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => window.open("https://wa.me/59177142692", "_blank")}
          sx={{
            backgroundColor: "#ff770d",
            "&:hover": { backgroundColor: "#e65e00" },
            fontWeight: "bold",
            textTransform: "none",
            color: "#fff",
          }}
        >
          Obtener plan {PLAN_NAMES[planDestino]}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradePlanModal;
